const usaFeatures = [
  { icon: "ri-truck-line", title: "2-5 Day Delivery", desc: "Fast shipping across all 50 US states from our local warehouses." },
  { icon: "ri-shield-check-line", title: "No Import Duties", desc: "Products already cleared customs. No surprise fees for your customers." },
  { icon: "ri-refresh-line", title: "Real-time Inventory", desc: "Live stock sync so you never oversell or disappoint customers." },
  { icon: "ri-money-dollar-circle-line", title: "USD Payments Only", desc: "All transactions in US dollars. Secure payment gateway included." },
  { icon: "ri-map-pin-line", title: "Multiple Locations", desc: "Warehouses in LA, New York, Chicago, Dallas, and Miami." },
  { icon: "ri-customer-service-2-line", title: "US-Based Support", desc: "Dedicated support team in US timezone for fast resolution." },
];

const usaStats = [
  { value: "5", label: "Warehouse Locations" },
  { value: "50K+", label: "Products in Stock" },
  { value: "2-5", label: "Days Delivery" },
  { value: "99.2%", label: "Order Accuracy" },
];

const USAWarehouseSection = () => (
  <section id="usa-warehouse" className="py-16 bg-[#B22222]">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="flex flex-col lg:flex-row gap-12 items-center">
        {/* Left Content */}
        <div className="lg:w-1/2">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-5xl">🇺🇸</span>
            <div>
              <div className="text-[#D4AF37] text-sm font-semibold uppercase tracking-wider">Local Fulfillment</div>
              <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight">
                USA Warehouse Dropshipping
              </h2>
            </div>
          </div>
          <p className="text-white/80 text-sm mb-8 leading-relaxed">
            Ship products directly from our US-based warehouses to your customers. No international shipping delays, no customs headaches. Your customers get fast, reliable delivery every time.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
            {usaStats.map((stat) => (
              <div key={stat.label} className="bg-white/10 rounded-lg p-4 text-center">
                <div className="text-2xl font-extrabold text-[#D4AF37]">{stat.value}</div>
                <div className="text-white/70 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            {usaFeatures.map((f) => (
              <div key={f.title} className="flex gap-3 items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-[#D4AF37]/20 rounded-lg flex-shrink-0">
                  <i className={`${f.icon} text-[#D4AF37]`}></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">{f.title}</div>
                  <div className="text-white/60 text-xs mt-0.5">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-3">
            <a
              href="https://wa.me/1234567890"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-[#25D366] text-white px-5 py-3 rounded-full font-semibold text-sm hover:bg-[#1ebe5d] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i> Contact via WhatsApp
            </a>
            <button className="flex items-center gap-2 bg-white text-[#B22222] px-5 py-3 rounded-full font-semibold text-sm hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-store-2-line"></i> Start Dropshipping
            </button>
          </div>
        </div>

        {/* Right Image */}
        <div className="lg:w-1/2">
          <div className="relative rounded-lg overflow-hidden h-80 md:h-[420px]">
            <img
              src="https://public.readdy.ai/ai/img_res/578e26a2e67476a86fb3501116763b2c.jpg"
              alt="USA Warehouse"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#B22222]/60 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <div className="bg-white/95 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-xs font-bold text-gray-800">Live Inventory Status</span>
                </div>
                <div className="grid grid-cols-3 gap-2 text-center">
                  <div>
                    <div className="text-sm font-bold text-[#C41E3A]">12,450</div>
                    <div className="text-[10px] text-gray-500">Items in Stock</div>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-[#C41E3A]">342</div>
                    <div className="text-[10px] text-gray-500">Orders Today</div>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-[#C41E3A]">98.7%</div>
                    <div className="text-[10px] text-gray-500">On-Time Rate</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default USAWarehouseSection;
